<template>
  <modal v-bind="attrs"
         v-on="$listeners"
         :name="name">
    <slot />
  </modal>
</template>

<script>
  export default {
    name: 'BaseModal',
    inheritAttrs: false,
    props: {
      name: { type: String, required: true },
      hideOverflow: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        attrs: {
          classes: this.hideOverflow ? '' : 'vm--modal-override-overflow-visible',
        },
      };
    },
    created: function () {
      this.attrs = {
        ...this.attrs,
        ...this.$attrs,
      }
    },
  };
</script>

<style lang="stylus">
  .vm--modal-override-overflow-visible
    overflow visible
</style>
